var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field-icon icon",class:_vm.css},[(_vm.title)?_c('tool-tip',{attrs:{"value":_vm._f("camelCaseTo")(_vm.title),"options":_vm.tipOptions}},[_c('icon',{class:_vm.icon,attrs:{"name":_vm.icon}})],1):_c('icon',{attrs:{"name":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }